var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan2Arm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "92px",
    viewBox: "0 0 36 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Man2Arm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man2Arm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.2645931,91.9803292 L28.2645931,91.9803292 C30.3925861,91.7742796 32.0732808,89.9995316 31.997537,88.0362287 L31.7355042,81.2113212 C31.6597603,79.2509341 29.8593084,77.8144184 27.7333626,78.0194961 C25.6053697,78.2255457 23.926722,80.0002938 24.0024659,81.9635967 L24.2644987,88.7885041 C24.339219,90.7498632 26.1396709,92.1863789 28.2645931,91.9803292",
    id: "Fill-133",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.97388435 C0,9.97388435 18.156977,35.8426733 20.6965123,47.0717095 C22.9929006,57.2305001 22.9949018,81 22.9949018,81 L33.3901863,80.3859906 C33.3901863,80.3859906 37.8568867,48.0042802 35.103222,38.3368981 C32.2004671,28.1489647 15.8275687,0 15.8275687,0 L0,9.97388435",
    id: "Fill-134-Copy",
    fill: "#C5C5E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan2Arm);
export default __webpack_public_path__ + "static/media/Man2Arm.5654a331503dfab2a6ef999bd6a4b682.svg";
export { ForwardRef as ReactComponent };